const SECONDS_PER_MINUTE = 60;
const SECONDS_PAD_LENGTH = 2;

/** Formats a duration in seconds as m:ss, e.g. 87 → "1:27". */
export const formatSecondsAsMinutesSeconds = (totalSeconds: number): string => {
  const wholeSeconds = Math.max(0, Math.floor(totalSeconds));
  const minutes = Math.floor(wholeSeconds / SECONDS_PER_MINUTE);
  const seconds = wholeSeconds % SECONDS_PER_MINUTE;
  return `${String(minutes)}:${String(seconds).padStart(SECONDS_PAD_LENGTH, '0')}`;
};
